import { Injectable } from '@angular/core';

import { Observable ,  Subscription } from 'rxjs';
import { Response } from '@angular/http';
import { Http } from '@angular/http';

import { RvService } from './rv.service';

@Injectable()
export class GDSCodeService {

  private rvService:RvService;
  private currentAuditId:string;
  private currentScheduleId:string;
  private subscription:Subscription;
  private GDSCodeList:Array<string>;

  //We can't include RvService as a parameter here because it results in a circular
  //dependency
  constructor(private http:Http) {
    this.rvService = new RvService(http);
  }

  storeGDSCodeList(auditId:string, scheduleId:string):void {
    //only get from the server is correct gds code list is not already cached
    if(auditId==this.currentAuditId && scheduleId==this.currentScheduleId && this.GDSCodeList) {
      console.log('GDS code list is already stored, and will last until this component is destroyed.');
    } else if(auditId==this.currentAuditId && scheduleId==this.currentScheduleId && this.subscription) {
      //if the subscription has been created, don't make another request, just wait for it to return
      console.log('Subscription already exists, GDS code list will be set when it returns.');
    } else {
      //check to make sure both variables exist and match expected pattern
      let guidPattern:RegExp = /^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/i;
      if(auditId && auditId.match(guidPattern) && scheduleId &&
        scheduleId.match(guidPattern)) {
        let t = this;
        this.GDSCodeList = null;
        this.subscription = this.rvService.getGDSCodeListFromServer(auditId, scheduleId)
        .subscribe(function(response) {
          t.GDSCodeList = response.json();
          t.currentAuditId = auditId;
          t.currentScheduleId = scheduleId;
        });
      } else {
        console.log('Error with input. Was not guid:' + auditId + ' ' + scheduleId);
      }
    }
  }

  //receive a function
  //if the gds code list is available, execute the function immediately, passing the gds code list as a parameter
  //otherwise, add the function to the list of functions that will be executed when the request finishes
  getGDSCodeList(f:Function):void {

    if(this.GDSCodeList) {
      f(this.GDSCodeList);
    } else {
      let t = this;
      this.subscription.add(function(){
        f(t.GDSCodeList);
      });
    }
  }
}
